import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-monotainer-live-status',
  templateUrl: './monotainer-live-status.component.html',
  styleUrls: ['./monotainer-live-status.component.css']
})
export class MonotainerLiveStatusComponent implements OnInit, OnChanges, OnDestroy {
  @Input() entityId: any;
  @Input() siteId: any;
  @Input() widgetData: any;
  destination: any;
  isloader: boolean = true;
  isError: boolean = false;
  lifecycleList: any = [];
  state: string = null;

  private _intervalTimer: any;
  private _subscription: Subscription;
  private _destination: any;
  private _monotainerDetailsSubscription: Subscription;
  private _getMonotainerHistorySubscription: Subscription;
  
  constructor(private _service: EntitiesServiceService, private _datePipe: DatePipe, private _dataSer: DataService, private _sharedService: ServicecallService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh' || res.name === 'tagRefresh') {
        this._getMonotainerData();
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.entityId && this.siteId) {
      // this.getMonotainerHistory();
      this._getMonotainerData();
    } else {
      this.isloader = false;
    }
  }
ngOnDestroy(): void {
  this._clearTimer();
  this._monotainerDetailsSubscription?.unsubscribe();
  this._getMonotainerHistorySubscription?.unsubscribe();
  if (this._subscription)
  this._subscription?.unsubscribe();
}  
private _refreshApi()  {
    if (+this.widgetData?.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._getMonotainerData();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  private _getMonotainerData() {
    const reqData = {
      siteId: this.siteId ? this.siteId : null,
      entityId: this.entityId,
      category: 'monotainer',
      type: '2'
    };
    this._monotainerDetailsSubscription = this._service.monotainerDetails(reqData).subscribe(
      {
        next: (result: any) => {
          if (Object.keys(result)?.length) {
            if (result?.state === 'init' || result?.state === 'init_mismatch') {
              this.state = 'init';
              this.lifecycleList = [{ action: 'Available', name: 'Available', at: '' },
              { action: result?.state === 'init_mismatch' ? 'Untagged' : '', name: result?.state === 'init_mismatch' ? 'Untagged' : '', at: '' }, { action: "", name: "", at: '' }, { action: "", name: "", at: '' }];
            } else {
              this.state = null;
              this._getMonotainerHistory();
            }
          } else {
            this.lifecycleList = [];
          }
          this._refreshApi();
          this.isloader = false;
        },
        error: () => {
          this.isError = true;
          this.isloader = false;
          this._refreshApi();
        }
      }
    )
  }
  private _getTimelineConfigurations(key: string) {
    const config = this._sharedService.getConfiguration('cnpTimeline')?.['cnpTimeline'];
    return config?.find(e => e.key === key);
  }

  private _getMonotainerHistory() {
    const payload = {
      id: this.entityId,
      offset: 1,
      limit: 1,
      from: this._datePipe.transform((new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999)), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ssZZ')
    };
    this._getMonotainerHistorySubscription = this._service.getMonotainerHistory(payload).subscribe({
      next: (resp: any) => {
        if (resp?.data?.length) {
          this._destination = resp?.data[0]?.destination;
          this.lifecycleList = [...resp?.data[0]?.timeline]?.reverse();
          this.lifecycleList?.map((item: any) => {
            // if (item.action?.toLowerCase() === "mismatch") {
            //   item.action = "Misplaced";
            // }
            item['color'] = this._getTimelineConfigurations(item?.action)?.color;
            item['name'] = this._getTimelineConfigurations(item?.action)?.name;
          })
          // if (resp?.data[0]?.entryTime) {
          //   this.lifecycleList?.push({
          //     at: resp?.data[0]?.entryTime,
          //     action: "entry"
          //   });
          // }
          // if (resp?.data[0]?.exitTime) {
          //   this.lifecycleList?.push({
          //     at: resp?.data[0]?.exitTime,
          //     action: "exit"
          //   });
          // }
          // this.lifecycleList?.sort((a, b) => (a.at > b.at ? 1 : -1));
          // const insideData = this.lifecycleList.filter((item: any) => item.action === 'inside' && !item.isValid);
          // if (insideData?.length) {
          //   insideData.forEach(element => {
          //     const index = this.lifecycleList?.indexOf(element);
          //     this.lifecycleList.splice(index + 1, 0, {
          //       at: element?.at,
          //       action: "Misplaced"
          //     });
          //   });
          // }
          this.state = null;
        } else {
          this.lifecycleList = [{ action: "Available", name: "Available", at: '' },
          { action: "", name: "", at: '' }, { action: "", name: "", at: '' },
          { action: "", name: "", at: '' }];
          this.state = 'init';
        }
        this.isloader = false;
      }, error: () => {
        this.isError = true;
        this.isloader = false;
      }
    });
  }
 
}
